import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Barra from '../../imgs/barra.svg';
import Impressora from '../../imgs/impressora.png';
import Recovery from '../../imgs/recovery.png';

import swal from 'sweetalert2';
import Pesquisa from '../../components/pesquisaSatisfacao/pesquisaSatisfacao';
import ReactGA from 'react-ga';

import './boletoGerado.css';

export default function BoletoGerado() {
	const [openModal, setOpenModal] = useState(false);
	const boleto = useSelector(state => state.boletoReducer);
	const usuario = useSelector(state => state.usuarioReducer);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({ type: 'SET_LOADING_PAGE', payload: false });
		if (!boleto.gerado)
			setTimeout(() => {
				setOpenModal(true);
			}, 5000);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [boleto]);

	const setCopy = () => {
		swal.fire({
			type: 'success',
			title: '<span style="color: white">Linha Digitável Copiada!!!</span>',
			background: '#3A3A39',
			confirmButtonColor: '#051773'
		});
	};

	const visualizarBoleto = () => {
		ReactGA.event({
			category: 'Click',
			action: 'Visualizar Boleto'
		});
		const win = window.open(boleto.linkPDF);
		win.focus();
	};

	return (
		<div className='Container-inicial'>
			<h1 className='Cabecalho-white'>
				{boleto.gerado ? `Emita agora a segunda via do seu boleto!` : `Não espere, pague seu boleto agora!`}
			</h1>
			<div className='wholePaper' id='boletoGerado'>
				<div className='PapelTop'>
					<img alt='impressora' src={Impressora} className='impressora' />
					<div className='tela-inicial-text-boleto'>
						<img src={Recovery} alt='Recovery' />
					</div>
					<div className='LinhaUm-boleto-gerado'>
						<div>
							<div className='Title1'>
								VALOR
								<br />
								DO BOLETO
								<br />
							</div>
							<div className='subTitleSpace'>{boleto.aVista}</div>
						</div>
						<div className='linha2-boleto-gerado'>
							<div>
								<div className='Title'>
									Nome<div className='Texto'>{usuario.nome}</div>
								</div>
								<div className='TitleSpace'>
									Nº Contrato<div className='Texto'>{boleto.NContrato}</div>
								</div>
							</div>
							<div>
								<div className='subTitle-boleto-gerado'>{boleto.id}</div>
								<div>
									<div className='Title-gerado-boleto'>
										Beneficiário<div className='Texto'>{boleto.beneficiario}</div>
									</div>
									<div className='TitleSpace'>
										Vencimento<div className='Texto'>{boleto.vencimento}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{boleto.isSMS ? (
					<div>
						<p className='labelSMS' style={{ fontSize: '1.3em', textAlign: 'center' }}>
							Você recebeu um SMS com a linha digitável para realizar o pagamento do boleto.
						</p>
						<p className='labelNaoEspere'>Não espere, pague agora!</p>
					</div>
				) : (
					<div className='PapelBottom'>
						<div className='Linha'>
							<img className='Boleto' alt='boleto' src={Barra} />
							<div className='itensBottom'>
								<p className='textoBottom-boleto-gerado'>{boleto.linhaDig}</p>
								<CopyToClipboard onCopy={setCopy} text={boleto.linhaDig}>
									<button className='botao-copiar-boleto-gerado'>Copiar linha digitável</button>
								</CopyToClipboard>
							</div>
						</div>
					</div>
				)}
				{!boleto.isSMS || boleto.isSMSComBoleto ? (
					<>
						<span className='labelButtonBig' style={{ whiteSpace: 'nowrap' }}>
							Clique e visualize o seu boleto agora mesmo
						</span>
						<button className='Button-boleto-gerado' onClick={visualizarBoleto}>
							{boleto.gerado ? 'Visualizar Segunda Via' : 'Visualizar Boleto'}
						</button>
					</>
				) : (
					<div style={{ height: '100px' }} />
				)}
			</div>
			{!boleto.gerado && openModal ? <Pesquisa Close={() => setOpenModal(false)} /> : null}
		</div>
	);
}
